import { useField } from 'formik';
import { useMemo } from 'react';

import GenericDropdown from '../GenericDropdown';

const Dropdown = ({
    name,
    heading,
    options = [],
    valueKey = '_id',
    displayValueKey = 'name',
    onSelect,
    size = '',
    readOnly = false,
    maxWidth = 'auto',
    grow = false,
    css = {},
    ...props
}) => {
    const [field, meta, { setValue, }] = useField(name);

    const error = useMemo(() => {
        if (meta.touched && meta.error) {
            return <div className='text-danger small'>{meta.error}</div>;
        }

        return null;
    }, [meta]);

    return (
        <>
            <GenericDropdown
                heading={heading}
                options={options}
                valueKey={valueKey}
                displayValueKey={displayValueKey}
                defaultValue={field.value}
                onSelect={(value) => {
                    if (onSelect) {
                        onSelect(value);
                    }

                    setValue(value);
                }}
                readOnly={readOnly}
                size={size}
                maxWidth={maxWidth}
                grow={grow}
                css={{
                    ...css,
                    toggle: `text-truncate ${css.toggle || ''} ${meta.touched && meta.error ? 'border border-danger' : ''}`,
                    dropdown: `${css.dropdown || ''}`,
                }}
                {...props}
            />
            {error}
        </>
    );
};

export default Dropdown;